import React, { useState } from "react";
import { Form, ProgressBar, Button } from "react-bootstrap";
import ReactS3Uploader from "react-s3-uploader";
// import Alert from "react-s-alert";
import { injectIntl } from "react-intl";

import getToken from "../helpers/getToken";
import getEncodedImageUrl from "../helpers/getEncodedImageUrl";

const ImageUpload = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  intl,
  ...props
}) => {
  const [showUpload, setShowUpload] = useState(0);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [showFileSizeWarning, setShowFileSizeWarning] = React.useState(false);
  return (
    <Form.Group controlId={name}>
      {props.label && (
        <Form.Label>
          {props.label}
          {props.required && <span className="text-danger">*</span>}
        </Form.Label>
      )}
      <div className="upload-photo">
        {value ? (
          <div
            className="uploaded-image-bg"
            style={{
              backgroundImage: `url('${getEncodedImageUrl(value, 200, 200)}')`,
              width: 200,
              height: 200,
            }}
          />
        ) : (
          <div className="u-photo" />
        )}
        <ReactS3Uploader
          type="file"
          accept={props.accept}
          signingUrl="/s3"
          signingUrlMethod="GET"
          preprocess={(file, next) => {
            if (props.maxSize && file.size > parseInt(props.maxSize)) {
              // Alert.warning(
              //   this.props.intl.formatMessage({ id: "error.fileTooBig" })
              // );
              setShowFileSizeWarning(true)
              setTimeout(() => {
                setShowUpload(0); 
                setShowFileSizeWarning(false)
              }, 3000);
            } else {
              setShowUpload(1);
              next(file);
            }
          }}
          onProgress={(p) => {
            if (p === 0) {
              setShowUpload(p + 1);
            } else {
              setShowUpload(p)
            }
          }}
          onError={(err) => {
            // Alert.error(
            //   intl.formatMessage({
            //     id: "error.file-upload",
            //   })
            // );
            setShowError(true); 
            setTimeout(() => {
              setShowUpload(0);
              setShowError(false);  
            }, 3000);
          }}
          onFinish={(url) => {
            setFieldValue(name, url.filename);
            // Alert.success(intl.formatMessage({id: 'label.photoUploaded'}));
            setShowSuccess(true);
            setTimeout(() => {
              setShowUpload(0); 
              setShowSuccess(false);
            }, 3000);
          }}
          signingUrlHeaders={{
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: getToken(),
          }}
          // signingUrlWithCredentials
          uploadRequestHeaders={{
            "x-amz-acl": "public-read",
          }}
          contentDisposition="auto"
          server={process.env.REACT_APP_API_HOST}
        />
        {
        showUpload !== 0 && <div className="upload-file-progress-container">
        <div className="upload-file-progress">
          <p>{intl.formatMessage({id: 'button.uploadingPhoto'})} { (showError || showSuccess || showFileSizeWarning) && <Button onClick={() => setShowUpload(0)} type="button"><img src="/icons/close.png" alt="close" /></Button> }</p>
          <div className="progress-container">
            <ProgressBar now={showUpload} label={`${showUpload}%`} />
            <span className="status-message text-success">{showSuccess && intl.formatMessage({ id: "label.photoUploaded" }) }</span>
            <span className="status-message text-danger">{showError && intl.formatMessage({ id: "error.file-upload" }) }</span>
            <span className="status-message text-warning">{showFileSizeWarning && intl.formatMessage({ id: "error.fileTooBig" }) }</span>
          </div>
        </div>
      </div>
      }
      </div>
      {touched[name] && errors[name] ? (
        <Form.Text>{errors[name]}</Form.Text>
      ) : (
        ""
      )}
    </Form.Group>
  );
};

export default injectIntl(ImageUpload);
